import React from "react"
import { twElementStyles } from "../../twElementStyles"
import { FieldErrorsImpl, DeepRequired, FieldValues } from 'react-hook-form'
interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string,
  register?: any,
  display?: string,
  errors?: FieldErrorsImpl<DeepRequired<FieldValues>>
}
export const ToggleField: React.FC<InputFieldProps> = ({ label, register, errors, display, ...props }) => {
  let random = `Togfel` + Math.round(Math.random() * 10000)
  return (
    <div>
      <div className="relative h-fit">
          {
              label && <label htmlFor={random} className={`block text-xs pb-2 dark:text-gray-300`}>{label}</label>
          }
        <label htmlFor={random} className="inline-flex relative items-center mr-5 cursor-pointer">
          <input id={random} {...register} type="checkbox" {...props} className="sr-only peer" />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          <span className="ml-3 text-sm  text-gray-900 dark:text-gray-300">{display}</span>
        </label>

      </div>

    </div>
  )
}